import request from '@/axios'
import type { UserType } from './types'

export const loginApi = (data): Promise<IResponse<UserType>> => {
  return request.post({ url: '/admin/login', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/admin/logout' })
}

// 获取当前登录管理员的角色名列表(后端从 token 里解析 admin_id, 查 sys_user_role/sys_role;
// 未分配角色时返回空数组, 前端按"全量可见"兜底, 见 src/router/roleRouterMap.ts)
export const getAdminRoleApi = (): Promise<IResponse<string[]>> => {
  return request.get({ url: '/admin/role' })
}

// 修改密码
export const UpdateAdminPw = (data): Promise<IResponse> => {
  return request.post({ url: '/admin/pw/update', data })
}
